module.exports = __webpack_public_path__ + "static/media/config-dark.fbe9f22e.svg";